/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { Tooltip } from '@/primitives/Tooltip';

export function DomainControllerBadge() {
  return (
    <Tooltip title="Domain Controller">
      <span
        data-testid="dc-badge"
        style={{
          backgroundColor: '#cecece',
          marginLeft: '8px',
          borderRadius: '5px',
          padding: '2px 6px',
          lineHeight: '14px',
          display: 'inline-block',
          verticalAlign: 'middle',
          position: 'relative',
          top: '-1px',
          fontSize: '12px',
          color: 'black',
        }}
      >
        DC
      </span>
    </Tooltip>
  );
}
